// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
  align-items: start;
}

.summary-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.summary-section-title {
  font-weight: 600;
  margin-bottom: 0.4rem;
  border-bottom: 1px solid #333;
}

.summary-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.1rem 0 0.1rem 0.75rem;
}
.summary-field .summary-label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.85rem;
}
.summary-field .summary-value {
  flex: 0 0 auto;
  width: 6.5rem;
  padding: 0.15rem 0.4rem;
  text-align: right;
  font-size: 0.85rem;
  background: #fbeee4;
  border: 1px solid #d9c7b6;
  min-height: 1.6rem;
}
.summary-field.highlighted .summary-value {
  background: #8db56a;
}

.summary-matrix,
.summary-pair-table {
  font-size: 0.85rem;
  border-collapse: separate;
  border-spacing: 2px;
}
.summary-matrix th[scope=row],
.summary-pair-table th[scope=row] {
  font-weight: 400;
  text-align: left;
  padding-left: 0.75rem;
  white-space: nowrap;
}
.summary-matrix td,
.summary-pair-table td {
  width: 3.5rem;
  padding: 0.15rem 0.4rem;
  text-align: right;
  background: #fbeee4;
  border: 1px solid #d9c7b6;
}

.summary-matrix tr.highlighted th[scope=row],
.summary-matrix tr.highlighted td {
  background: #8db56a;
}

.summary-pair-table {
  margin-bottom: 0.75rem;
}
.summary-pair-table thead th {
  font-weight: 400;
  text-align: right;
  padding: 0 0.4rem;
  background: none;
  border: none;
}

@media (max-width: 1200px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 768px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/design-summary/design-summary.component.scss"],"names":[],"mappings":"AAIA;EACE,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAHF;;AAMA;EACE,gBAAA;EACA,qBAAA;EACA,6BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AAHF;AAKE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AAME;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBA9CO;EA+CP,yBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,mBAlDW;AA6Cf;;AASA;;EAEE,kBAAA;EACA,yBAAA;EACA,mBAAA;AANF;AAQE;;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AALJ;AAQE;;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAzEO;EA0EP,yBAAA;AALJ;;AAUE;;EAEE,mBA/EW;AAwEf;;AAWA;EACE,sBAAA;AARF;AAUE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AARJ;;AAYA;EACE;IACE,gDAAA;EATF;AACF;AAYA;EACE;IACE,0BAAA;EAVF;AACF","sourcesContent":["$value-bg: #fbeee4;\n$value-border: #d9c7b6;\n$highlight-bg: #8db56a;\n\n:host {\n  display: block;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.summary-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.summary-section-title {\n  font-weight: 600;\n  margin-bottom: 0.4rem;\n  border-bottom: 1px solid #333;\n}\n\n.summary-field {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.1rem 0 0.1rem 0.75rem;\n\n  .summary-label {\n    flex: 1 1 auto;\n    min-width: 0;\n    font-size: 0.85rem;\n  }\n\n  .summary-value {\n    flex: 0 0 auto;\n    width: 6.5rem;\n    padding: 0.15rem 0.4rem;\n    text-align: right;\n    font-size: 0.85rem;\n    background: $value-bg;\n    border: 1px solid $value-border;\n    min-height: 1.6rem;\n  }\n\n  &.highlighted .summary-value {\n    background: $highlight-bg;\n  }\n}\n\n.summary-matrix,\n.summary-pair-table {\n  font-size: 0.85rem;\n  border-collapse: separate;\n  border-spacing: 2px;\n\n  th[scope='row'] {\n    font-weight: 400;\n    text-align: left;\n    padding-left: 0.75rem;\n    white-space: nowrap;\n  }\n\n  td {\n    width: 3.5rem;\n    padding: 0.15rem 0.4rem;\n    text-align: right;\n    background: $value-bg;\n    border: 1px solid $value-border;\n  }\n}\n\n.summary-matrix tr.highlighted {\n  th[scope='row'],\n  td {\n    background: $highlight-bg;\n  }\n}\n\n.summary-pair-table {\n  margin-bottom: 0.75rem;\n\n  thead th {\n    font-weight: 400;\n    text-align: right;\n    padding: 0 0.4rem;\n    background: none;\n    border: none;\n  }\n}\n\n@media (max-width: 1200px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
